var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 11.9059V20.0801C1.25 23.0834 1.25 23.0834 4.08333 24.9959L11.875 29.5009C13.0508 30.1809 14.9633 30.1809 16.125 29.5009L23.9167 24.9959C26.75 23.0834 26.75 23.0834 26.75 20.0943V11.9059C26.75 8.91676 26.75 8.91676 23.9167 7.00426L16.125 2.49926C14.9633 1.81926 13.0508 1.81926 11.875 2.49926L4.08333 7.00426C1.25 8.91676 1.25 8.91676 1.25 11.9059Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.2501C16.3472 20.2501 18.25 18.3473 18.25 16.0001C18.25 13.6529 16.3472 11.7501 14 11.7501C11.6528 11.7501 9.75 13.6529 9.75 16.0001C9.75 18.3473 11.6528 20.2501 14 20.2501Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 11.9059V20.0801C1.25 23.0834 1.25 23.0834 4.08333 24.9959L11.875 29.5009C13.0508 30.1809 14.9633 30.1809 16.125 29.5009L23.9167 24.9959C26.75 23.0834 26.75 23.0834 26.75 20.0943V11.9059C26.75 8.91676 26.75 8.91676 23.9167 7.00426L16.125 2.49926C14.9633 1.81926 13.0508 1.81926 11.875 2.49926L4.08333 7.00426C1.25 8.91676 1.25 8.91676 1.25 11.9059Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.2501C16.3472 20.2501 18.25 18.3473 18.25 16.0001C18.25 13.6529 16.3472 11.7501 14 11.7501C11.6528 11.7501 9.75 13.6529 9.75 16.0001C9.75 18.3473 11.6528 20.2501 14 20.2501Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.50a4940618076a0f8829a1700adaf365.svg";
export { ForwardRef as ReactComponent };